import TextControl from './TextControl'
export default TextControl


// WEBPACK FOOTER //
// ./src/modules/TextControl/index.js